import {
    calendarBoardTasksFolderName,
    projectMocaTasksFolderName,
} from './getTaskFolderName.locstring.json';
import loc from 'owa-localize';

export default function getTaskFolderName(projectName: string, appName?: string): string {
    const folderNameResourceId = appName
        ? calendarBoardTasksFolderName
        : projectMocaTasksFolderName;

    return loc(folderNameResourceId, projectName);
}
